import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../ConfirmationModal';

function CancelChangesConfirmationModal({ show, onCancel, onConfirm }) {
  return (
    <ConfirmationModal
      show={show}
      title="Cancel Changes"
      onCancel={onCancel}
      onConfirm={onConfirm}
      cancelButtonLabel="No"
      confirmButtonLabel="Yes"
    >
      Are you sure you want to undo your changes you have made to this order?
    </ConfirmationModal>
  );
}

CancelChangesConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default CancelChangesConfirmationModal;
